<style type="text/css">
	  *    { margin: 0; padding: 0; box-sizing: border-box; }
	  html { width: 100%; height: 100%; }

	  #title {
	      text-align: center;
	      color: grey;
	      padding: .5rem 0;
	  }

	  #web_cam    { display: none }

	  .tryon-stage {
	      margin: auto;
	      width: 640px;
	      height: 480px;
	      position: relative;
	  }
	  #img_stream { height: 100%;width: 100% }
	  #t3d_cvs { position: absolute;left: 0;top: 0;}

	  .glass-list {
	      padding-top: 1rem;
	      display: flex;
	      flex-flow: row nowrap;
	      justify-content: space-between;
	      list-style: none;
	      margin: auto;
	      width: 640px;
	  }
	  .glass__item {
	      width: 22%;
	      display: inline-flex;
	      height: 8rem;
	      margin: auto;
	      overflow: hidden;
	      border-radius: 10px;
	  }
	  .glass__item img {
	      width: 100%;
	      pointer-events: none;
	  }
  </style>
<template>
  <div>
    <h2 id="title"> PanxSoft Glasses TryOn Demo </h2>

    <div id="tryon_stage" class="tryon-stage" ></div>>

    <ul class="glass-list" onclick="clickChangeGlass()">
      <li class="glass__item" data-idx="-1">
        <img src="https://gz.bcebos.com/v1/try-on-api/mp_sdk_dev/exhibit_asset/cencel.png" alt="" class="glass__img">
      </li>
      <li class="glass__item" data-idx="0">
        <img src="https://gz.bcebos.com/v1/try-on-api/gl-glass-tryon/glass-thumb/AX_glasses%252Fthumb%252Fpanx_xhh_sdk8207.jpg?authorization=bce-auth-v1%2F61c99e540e874c98a8cf7c68fce37479%2F2018-03-13T08%3A07%3A02Z%2F1800%2Fhost%2F3535859ee628e84b9c97db9f70e0deef1f160e643cd1ce5f2d87945f59a684ec" alt="" class="glass__img">
      </li>
      <li class="glass__item" data-idx="1">
        <img src="https://gz.bcebos.com/v1/try-on-api/gl-glass-tryon/glass-thumb/panx_as_tit7725.jpg" alt="" class="glass__img">
      </li>
      <li class="glass__item" data-idx="2">
        <img src="https://gz.bcebos.com/v1/try-on-api/gl-glass-tryon/glass-thumb/panx_as_glsg405.jpg" alt="" class="glass__img">
      </li>
    </ul>
  </div>
</template>

<script>
 var first_glass = "sdk8207";
      var sdk_ready = false;
      var first_loaded = false;

    var pkxTryOn;
export default {
    data(){
        return{


        }
    },
    mounted() {
      pkxTryOn = new GLTryOn({
        stage: "#tryon_stage" ,

        // 你的 appid
        app_id : 'rGcbbba7ajhBf7xW0ujdJky4xryxby9W' ,

        // 在后台用 md5( app_secret + token + timestamp ) 生成的签名，两小时内有效
        // 此签名只在 tryon.xiaojingxiuxiu.com 和 localhost 域名下有效，不要用于你的生产环境
        signature : 'a8a167688333621963b2d3bc25d9da07' ,

        // unix 时间
        timestamp : '1489504583' ,

        size: {
          width: 640,
          height: 480
        }
      });

      pkxTryOn
        .on("ready", function () {
          console.info("gl tryon ready!");
          sdk_ready = true;
          onReady();
        })
        .on("error", function (error_type, error_msg) {
          console.info(error_type, error_msg);
          alert(error_type + ':' + error_msg);
        })
        .on("glass-loaded", function (glass) {
          if (glass.name === first_glass) {
            first_loaded = true;
            onReady();
          }
          console.info(glass.name + " loaded");
        });
        this.asyncLoadGlass();

    },
    methods: {
         asyncLoadGlass() {
          // 加载完成直接切换
          let show = true;

          // pkxTryOn.loadGlassKey('uuid-not-exist'); // 加载素材失败会触发 error 错误

          pkxTryOn.loadGlassKey('demo-uuid-1', show);
          pkxTryOn.loadGlassKey('demo-uuid-2');
          pkxTryOn.loadGlassKey('demo-uuid-3');
        },

         onReady() {
          if (sdk_ready && first_loaded) {
            pkxTryOn.changeGlass(first_glass)
          }
        },

         clickChangeGlass() {
          if (event.target.nodeName.toUpperCase() !== "LI") return false;

          var show_idx = parseInt(event.target.dataset.idx);
          if (show_idx === -1) return pkxTryOn.hideGlass();

          pkxTryOn.changeGlass('demo-uuid-' + show_idx);
        },

        /**
         * @return {string}
         */
         assetRoot() {
        	console.log("982397123971293812391")
          return location.host === "tryon.xiaojingxiuxiu.com"
            ? "https://gz.bcebos.com/v1/try-on-api/gl-glass-tryon/"
            : "";
        }


    }
}
</script>
